<template>
	<v-app>
		<v-main class="grey lighten-3">
			<v-container fill-height>
				<v-row justify="center" align="center">
					<v-col cols="12" sm="8" md="6" lg="4">
						<v-card class="elevation-12">
							<v-toolbar color="primary" dark flat>
								<v-toolbar-title>微信登录</v-toolbar-title>
							</v-toolbar>
							<v-card-text class="text-center py-8">
								<v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
								<div v-if="!loading && errorMsg" class="error--text">{{ errorMsg }}</div>
								<div v-if="!loading && !errorMsg">登录成功，正在跳转...</div>
							</v-card-text>
							<v-card-actions class="justify-center grey lighten-4" v-if="!loading && errorMsg">
								<v-btn text small color="secondary" to="/login">返回登录页</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
	export default {
		name: 'WechatLoginView',
		data: () => ({
			loading: true,
			errorMsg: ''
		}),
		created() {
			this.handleLogin();
		},
		methods: {
			async handleLogin() {
				const token = this.$route.query.token;
				if (!token) {
					this.loading = false;
					this.errorMsg = "微信授权失败，请重试";
					return;
				}
				try {
					//保存token
					localStorage.setItem('authToken', token);
					//获取用户信息和权限
					const res = await this.$axios.post('/kt-supplier/tokenlogin', {}, {
						headers: {
							token: token
						}
					});
					if (res.data.state == 200 && res.data.data && res.data.data.status == "1") {
						const user = res.data.data.data[0];
						const functions = res.data.data.data[1] || [];
						localStorage.setItem('venderId', user.venderIdString);
						localStorage.setItem('menu', JSON.stringify(functions));
						this.$router.replace('/');
					} else {
						localStorage.removeItem('authToken');
						this.loading = false;
						this.errorMsg = "登录状态获取失败，请重试";
					}
				} catch (e) {
					localStorage.removeItem('authToken');
					this.loading = false;
					this.errorMsg = "登录失败，请重试";
				}
			}
		}
	}
</script>

<style>
</style>
